define("settings/templates/devices", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <MigrationBanner />
  
  <Shared::Card class="tAC--card" as |card|>
    <card.header @title={{t "account.devices.title"}} @titleClass="tAC--header__title" />
    <card.body>
      <Section
        @hideDivider={{true}}
        @subtitle={{t "account.devices.notifications_description"}}
        @title={{t "account.devices.notifications_title"}}
        @titleStyles="u--m__t__0"
      />
      {{! Email }}
      <Section @title={{t "shared_words.email"}}>
        <Shared::Ui::CheckboxSwitch
          @labelText={{t "account.devices.email_notification.description"}}
          @propertyToggled={{this.emailFollowUp}}
          @textClass="u--text--hair"
          @toggleAction={{perform this.toggleEmailNotifications}}
        />
  
        <Shared::Ui::CheckboxSwitch
          @checkboxClass="qa--emailNoti_high_performing_post_checkBox"
          @labelText={{t "account.devices.high_performing_post.description"}}
          @propertyToggled={{this.highPerformingContentEmail}}
          @textClass="u--text--hair qa--emailNoti_high_performing_post_text"
          @toggleAction={{perform this.toggleHighPerformanceEmails}}
        />
  
        <Shared::Ui::CheckboxSwitch
          @labelText={{t "account.devices.high_performing_post.comments"}}
          @propertyToggled={{this.highPerformingCommentsEmail}}
          @textClass="u--text--hair"
          @toggleAction={{perform this.toggleHighPerformanceCommentsEmails}}
        />
  
        {{#if this.showApprovalFlowEmailToggle}}
          <Shared::Ui::CheckboxSwitch
            @checkboxClass="qa--emailNoti_submittedForReview_checkBox"
            @labelText={{t "account.devices.approval_flow_submitted_for_review"}}
            @propertyToggled={{this.postReviewEmailNotifications}}
            @textClass="u--text--hair qa--emailNoti_submittedForReview_text"
            @toggleAction={{perform this.togglApprovalFlowSubmittedForReviewEmails}}
          />
        {{/if}}
  
        <hr class="tAC--section__divider" />
  
      </Section>
  
      {{! Push Notifications }}
      <Section @title={{t "account.devices.push_notification.title"}}>
        <Shared::Ui::CheckboxSwitch
          @labelText={{t "account.devices.push_notification.description"}}
          @propertyToggled={{this.pushFollowUp}}
          @textClass="u--text--hair"
          @toggleAction={{perform this.togglePushNotifications}}
        />
  
        <Shared::Ui::CheckboxSwitch
          @labelText={{t "account.devices.high_performing_post.description"}}
          @propertyToggled={{this.highPerformingContentPushNotifications}}
          @textClass="u--text--hair"
          @toggleAction={{perform this.toggleHighPerformancePushNotifications}}
        />
  
        <Shared::Ui::CheckboxSwitch
          @labelText={{t "account.devices.high_performing_post.comments"}}
          @propertyToggled={{this.highPerformingCommentsPushNotifications}}
          @textClass="u--text--hair"
          @toggleAction={{perform this.toggleHighPerformanceCommentsPushNotifications}}
        />
  
        <hr class="tAC--section__divider" />
  
      </Section>
  
      {{! Devices }}
      <Section as |section|>
        <div class="tAC--section__item u--m__b__lg">
          <section.details
            @description={{t "account.devices.devices_description"}}
            @descriptionStyles="u--m__b__0"
            @title={{t "account.devices.devices_title"}}
            @titleStyles="tAC--section__title u--text--bold u--m__t__0"
          >
            <ol class="u--p__l__sm">
              <li class="u--m__xs">
                {{html-safe (t "account.devices.devices_description_step_1")}}
              </li>
              <li class="u--m__xs">
                {{html-safe (t "account.devices.devices_description_step_2" email=this.currentUserModel.email)}}
              </li>
            </ol>
          </section.details>
          <section.action>
            <Shared::AppstoreLinks @origin="settings" />
          </section.action>
        </div>
        <table class="o--table tAC--table">
          <thead>
            <tr>
              <th>
                {{t "account.devices.table.header.device"}}
              </th>
              <th>
                {{t "account.devices.table.header.added"}}
              </th>
              <th style="width:270px">
                {{t "account.devices.table.header.test"}}
              </th>
              <th style="width:110px">
                {{t "account.devices.table.header.action"}}
              </th>
            </tr>
          </thead>
          <tbody>
            {{#each @model as |device|}}
              <Devices::DeviceItem
                @device={{device}}
                @disconnect={{perform this.disconnectDevice device}}
                @numberOfDevices={{@model.length}}
              />
            {{/each}}
          </tbody>
        </table>
      </Section>
    </card.body>
  </Shared::Card>
  */
  {
    "id": "egbVo5xo",
    "block": "[[[8,[39,0],null,null,null],[1,\"\\n\\n\"],[8,[39,1],[[24,0,\"tAC--card\"]],null,[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"header\"]],null,[[\"@title\",\"@titleClass\"],[[28,[37,2],[\"account.devices.title\"],null],\"tAC--header__title\"]],null],[1,\"\\n  \"],[8,[30,1,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n    \"],[8,[39,3],null,[[\"@hideDivider\",\"@subtitle\",\"@title\",\"@titleStyles\"],[true,[28,[37,2],[\"account.devices.notifications_description\"],null],[28,[37,2],[\"account.devices.notifications_title\"],null],\"u--m__t__0\"]],null],[1,\"\\n\"],[1,\"    \"],[8,[39,3],null,[[\"@title\"],[[28,[37,2],[\"shared_words.email\"],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,4],null,[[\"@labelText\",\"@propertyToggled\",\"@textClass\",\"@toggleAction\"],[[28,[37,2],[\"account.devices.email_notification.description\"],null],[30,0,[\"emailFollowUp\"]],\"u--text--hair\",[28,[37,5],[[30,0,[\"toggleEmailNotifications\"]]],null]]],null],[1,\"\\n\\n      \"],[8,[39,4],null,[[\"@checkboxClass\",\"@labelText\",\"@propertyToggled\",\"@textClass\",\"@toggleAction\"],[\"qa--emailNoti_high_performing_post_checkBox\",[28,[37,2],[\"account.devices.high_performing_post.description\"],null],[30,0,[\"highPerformingContentEmail\"]],\"u--text--hair qa--emailNoti_high_performing_post_text\",[28,[37,5],[[30,0,[\"toggleHighPerformanceEmails\"]]],null]]],null],[1,\"\\n\\n      \"],[8,[39,4],null,[[\"@labelText\",\"@propertyToggled\",\"@textClass\",\"@toggleAction\"],[[28,[37,2],[\"account.devices.high_performing_post.comments\"],null],[30,0,[\"highPerformingCommentsEmail\"]],\"u--text--hair\",[28,[37,5],[[30,0,[\"toggleHighPerformanceCommentsEmails\"]]],null]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showApprovalFlowEmailToggle\"]],[[[1,\"        \"],[8,[39,4],null,[[\"@checkboxClass\",\"@labelText\",\"@propertyToggled\",\"@textClass\",\"@toggleAction\"],[\"qa--emailNoti_submittedForReview_checkBox\",[28,[37,2],[\"account.devices.approval_flow_submitted_for_review\"],null],[30,0,[\"postReviewEmailNotifications\"]],\"u--text--hair qa--emailNoti_submittedForReview_text\",[28,[37,5],[[30,0,[\"togglApprovalFlowSubmittedForReviewEmails\"]]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n      \"],[10,\"hr\"],[14,0,\"tAC--section__divider\"],[12],[13],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n\"],[1,\"    \"],[8,[39,3],null,[[\"@title\"],[[28,[37,2],[\"account.devices.push_notification.title\"],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,4],null,[[\"@labelText\",\"@propertyToggled\",\"@textClass\",\"@toggleAction\"],[[28,[37,2],[\"account.devices.push_notification.description\"],null],[30,0,[\"pushFollowUp\"]],\"u--text--hair\",[28,[37,5],[[30,0,[\"togglePushNotifications\"]]],null]]],null],[1,\"\\n\\n      \"],[8,[39,4],null,[[\"@labelText\",\"@propertyToggled\",\"@textClass\",\"@toggleAction\"],[[28,[37,2],[\"account.devices.high_performing_post.description\"],null],[30,0,[\"highPerformingContentPushNotifications\"]],\"u--text--hair\",[28,[37,5],[[30,0,[\"toggleHighPerformancePushNotifications\"]]],null]]],null],[1,\"\\n\\n      \"],[8,[39,4],null,[[\"@labelText\",\"@propertyToggled\",\"@textClass\",\"@toggleAction\"],[[28,[37,2],[\"account.devices.high_performing_post.comments\"],null],[30,0,[\"highPerformingCommentsPushNotifications\"]],\"u--text--hair\",[28,[37,5],[[30,0,[\"toggleHighPerformanceCommentsPushNotifications\"]]],null]]],null],[1,\"\\n\\n      \"],[10,\"hr\"],[14,0,\"tAC--section__divider\"],[12],[13],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n\"],[1,\"    \"],[8,[39,3],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"tAC--section__item u--m__b__lg\"],[12],[1,\"\\n        \"],[8,[30,2,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[28,[37,2],[\"account.devices.devices_description\"],null],\"u--m__b__0\",[28,[37,2],[\"account.devices.devices_title\"],null],\"tAC--section__title u--text--bold u--m__t__0\"]],[[\"default\"],[[[[1,\"\\n          \"],[10,\"ol\"],[14,0,\"u--p__l__sm\"],[12],[1,\"\\n            \"],[10,\"li\"],[14,0,\"u--m__xs\"],[12],[1,\"\\n              \"],[1,[28,[35,7],[[28,[37,2],[\"account.devices.devices_description_step_1\"],null]],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"li\"],[14,0,\"u--m__xs\"],[12],[1,\"\\n              \"],[1,[28,[35,7],[[28,[37,2],[\"account.devices.devices_description_step_2\"],[[\"email\"],[[30,0,[\"currentUserModel\",\"email\"]]]]]],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,2,[\"action\"]],null,null,[[\"default\"],[[[[1,\"\\n          \"],[8,[39,8],null,[[\"@origin\"],[\"settings\"]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"table\"],[14,0,\"o--table tAC--table\"],[12],[1,\"\\n        \"],[10,\"thead\"],[12],[1,\"\\n          \"],[10,\"tr\"],[12],[1,\"\\n            \"],[10,\"th\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"account.devices.table.header.device\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"th\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"account.devices.table.header.added\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"th\"],[14,5,\"width:270px\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"account.devices.table.header.test\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"th\"],[14,5,\"width:110px\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"account.devices.table.header.action\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,3]],null]],null],null,[[[1,\"            \"],[8,[39,11],null,[[\"@device\",\"@disconnect\",\"@numberOfDevices\"],[[30,4],[28,[37,5],[[30,0,[\"disconnectDevice\"]],[30,4]],null],[30,3,[\"length\"]]]],null],[1,\"\\n\"]],[4]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"card\",\"section\",\"@model\",\"device\"],false,[\"migration-banner\",\"shared/card\",\"t\",\"section\",\"shared/ui/checkbox-switch\",\"perform\",\"if\",\"html-safe\",\"shared/appstore-links\",\"each\",\"-track-array\",\"devices/device-item\"]]",
    "moduleName": "settings/templates/devices.hbs",
    "isStrictMode": false
  });
});